<template>
  <TourFilterPopupWrapper
    v-if="groups.length"
    :title="title"
    :items-count="itemsCount"
    is-modal-only
    :static-title="t('tour-activities.popup-title')"
    modal-class="tours-activities-modal"
    filter-key="toursActivities"
    class="filter-tours-activities"
    :is-active="isActive"
    :is-full-height="!withoutTitle"
    :modal-size="UiModalSize.M"
    :is-disabled-reset-button="isDisabledResetButton"
    is-footer-buttons-vertical
    :is-scroll="props.isScroll"
    v-bind="$attrs"
  >
    <div class="popup__content">
      <ToursActivitiesPopupContent
        :groups="groups"
        :without-title="withoutTitle"
      />
    </div>
  </TourFilterPopupWrapper>
</template>

<script setup lang="ts">
  import { computed, toRef } from 'vue';
  import { TourFilterPopupWrapper } from '@/entities/filter/popup-wrapper';
  import { ToursActivitiesPopupContent } from '@/entities/tour-activities';
  import { useToursActivitiesAsChipsGroups, useTourActivitiesTitle } from '@/features/filter/tour-activities';
  import ru from '../i18n/ru.json';
  import { useI18n } from '@experience/i18n';
  import { UiModalSize } from '@experience/core-modal-ui';
  import { locales } from '../i18n';

  defineOptions({ inheritAttrs: false });

  type MessageSchema = typeof ru;

  const { t } = useI18n<
    {
      message: MessageSchema;
    },
    'ru'
  >({
    inheritLocale: true,
    messages: {
      ru,
    },
  });

  interface Props {
    isScroll?: boolean;
    activityCounts?: Record<string, number> | null;
  }

  const props = defineProps<Props>();

  const { title, itemsCount, isActive, isDisabledResetButton } = useTourActivitiesTitle(locales.ru);

  const groups = useToursActivitiesAsChipsGroups(toRef(props, 'activityCounts'));
  const withoutTitle = computed(() => Object.keys(props.activityCounts ?? {}).length < 10);
</script>

<style scoped lang="scss">
  .ui-modal__body-content-wrapper {
    padding-top: 0 !important;
  }
</style>
<style lang="scss">
  .tours-activities-modal {
    .ui-modal__body-content-wrapper {
      padding-top: 8px;
      padding-bottom: 0;
    }

    .ui-modal-header {
      padding-bottom: 16px;
    }
  }
</style>
